import React, { useState, useEffect, useRef } from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Form, InputGroup } from 'react-bootstrap';
import '../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import { Container, Row, Col, Card, Button, Table } from "react-bootstrap";

const Standard_Division = () => {

  const [formData, setFormData] = useState({
    std_id:'',
    section_id: '',
    std_hierarchy: '',
    std_short_name: '',
    std_full_name: '',
    roll_prefix: '',
    last_std: 'N',
    gen_gr: 'N',
  });

  const [isEditable, setIsEditable] = useState(false);
  const [ddlSections, setDdlSections] = useState([]);
  const [savedData, setSavedData] = useState([]);

  const [divisions, setDivisions] = useState([]);
  const [ddlDivisions, setDdlDivisions] = useState([]);
  const [showDivisionCard, setShowDivisionCard] = useState(false);

//  const premTypeRef = useRef(null);

  // Fetch data on mount
  useEffect(() => {
    fetchSavedData();
    populateSection();
  }, []);

  const fetchSavedData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/get_standard`);
      setSavedData(response.data);
    } catch (error) {
      console.error("Error fetching saved data:", error);
    }
  };

  const populateSection = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(response.data);
      const div_resp = await axios.get(`${BASE_URL}/api/ddl_divisions`);
      setDdlDivisions(div_resp.data);
    } catch (error) {
      console.error("Error fetching saved data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleNew = () => {
    setIsEditable(true);
    setFormData({
      std_id: '',
      section_id: '',
      std_hierarchy: '',
      std_short_name: '',
      std_full_name: '',
      roll_prefix: '',
      last_std: 'N',
      gen_gr: 'N',

    });

    // setTimeout(() => {
    //   if (premTypeRef.current) {
    //     premTypeRef.current.focus();
    //   }
    // }, 0);

  };

  const handleClear = () => {
    const isConfirmed = window.confirm("Sure you want to clear?");
    if (!isConfirmed) return;

    setIsEditable(false);
    setFormData({
      std_id:'',
      section_id: '',
      std_hierarchy: '',
      std_short_name: '',
      std_full_name: '',
      roll_prefix: '',
      last_std: 'N',
      gen_gr: 'N',

    });
  };

  const handleSave = async () => {
    // const { sec_hierarchy, section_desc , sec_prefix, school_name   } = formData;

    if (!formData.std_hierarchy) {
      toast.error("Please enter Standard Hierarchy !");
      return;
    }

    if (!formData.std_short_name) {
      toast.error("Please enter Standard Short Name !");
      return;
    }

     if (!formData.std_full_name) {
      toast.error("Please enter Standard Full Name !");
      return;
    }
    
    if (!formData.roll_prefix) {
      toast.error("Please enter Roll No Prefix !");
      return;
    }

    if (!formData.last_std) {
      toast.error("Please enter Last Standard !");
      return;
    }

    if (!formData.gen_gr) {
      toast.error("Please enter Generate GR !");
      return;
    }

    const isConfirmed = window.confirm("Do you want to save this record?");

    if (!isConfirmed) return;

    try {

      const response = await axios.post(`${BASE_URL}/api/save_standard`, formData);

      if (response.data.message === '1') {
        toast.success("Section saved successfully!");
        fetchSavedData();
        setIsEditable(false);
        setFormData({
          std_id:'',
          section_id: '',
          std_hierarchy: '',
          std_short_name: '',
          std_full_name: '',
          roll_prefix: '',
          last_std: 'N',
          gen_gr: 'N',

        });
        //handleClear();
      } else {
        toast.error("Failed to save.");
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleRowClick = async (row) => {
    setFormData({
      std_id: row.std_id,
      section_id: row.section_id,
      std_hierarchy: row.std_hierarchy,
      std_short_name: row.std_short_name,
      std_full_name: row.std_full_name,
      roll_prefix: row.roll_prefix,
      last_std: row.last_std,
      gen_gr: row.gen_gr,
    });

    setIsEditable(true);
    setShowDivisionCard(true);
    setDivisions([]);

    try {
      //const res = await axios.get(`${BASE_URL}/api/get_divisions`, row.std_id);
      const res = await axios.get(`${BASE_URL}/api/get_divisions`, {params: {p_div_id: row.std_id}});

      if (res.data.length > 0) 
        setDivisions(res.data || []);

    } catch (err) {
      console.error("Error loading divisions", err);
      setDivisions([]);
    }
  };

  const handleAddDivision = () => {
    setDivisions(prev => ([
      ...prev,
      {
        division_id: null,
        std_id: formData.std_id,
        division_name: '',
        capacity: '',
        active: 'Y'
      }
    ]));
  };

  const handleDivisionChange = (index, field, value) => {
    const updated = [...divisions];
    updated[index][field] = value;
    setDivisions(updated);
  };

  const handleSaveDivisions = async () => {

    // if (!formData.std_id) {
    //   toast.error("Please select a Standard first");
    //   return;
    // }

    try {

      const payload = {
        details: divisions,
      };

      await axios.post(`${BASE_URL}/api/save_division`, payload);
      toast.success("Divisions saved successfully");

    } catch (err) {

      console.error(err);
      toast.error("Error saving divisions");

    }

  };


  return (
    <Container fluid className="p-3">
      <Card className="mb-3 p-3">

        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Section
              </InputGroup.Text>

              <Form.Select
                name="section_id"
                value={formData.section_id}
                onChange={handleChange}
                disabled={!isEditable}
              >
                <option value="">-- Select Section --</option>

                {ddlSections.map((Sec) => (
                  <option key={Sec.section_id} value={Sec.section_id}>
                    {Sec.section_desc}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Std Hierarchy
              </InputGroup.Text>

              <Form.Control
                type="number"
                name="std_hierarchy"
                className="scty-text-left"
                value={formData.std_hierarchy}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Std Short Name
              </InputGroup.Text>

              <Form.Control
                type="text"
                name="std_short_name"
                className="scty-text-left"
                value={formData.std_short_name}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Std Full Name
              </InputGroup.Text>

              <Form.Control
                type="text"
                name="std_full_name"
                className="scty-text-left"
                value={formData.std_full_name}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Roll Prefix
              </InputGroup.Text>

              <Form.Control
                type="text"
                name="roll_prefix"
                className="scty-text-left"
                value={formData.roll_prefix}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Last Standard
              </InputGroup.Text>

              {/* <Form.Control
                type="text"
                name="last_std"
                className="scty-text-left"
                value={formData.last_std}
                onChange={handleChange}
                disabled={!isEditable}
              /> */}

              <Form.Select
                name="last_std"
                value={formData.last_std}
                onChange={handleChange}
                disabled={!isEditable}
              >
                <option value="N">No</option>
                <option value="Y">Yes</option>
              </Form.Select>

            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Generate GR
              </InputGroup.Text>

              {/* <Form.Control
                type="text"
                name="gen_gr"
                className="scty-text-left"
                value={formData.gen_gr}
                onChange={handleChange}
                disabled={!isEditable}
              /> */}

              <Form.Select
                name="gen_gr"
                value={formData.gen_gr}
                onChange={handleChange}
                disabled={!isEditable}
              >
                <option value="N">No</option>
                <option value="Y">Yes</option>
              </Form.Select>

            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">
          <Col md="auto" className="d-flex justify-content-end ms-auto">

            <button
              style={{ width: "135px" }}
              className="btn btn-primary me-2"
              disabled={isEditable}
              onClick={handleNew}
            >
              New
            </button>

            <button
              style={{ width: "135px" }}
              className="btn btn-secondary me-2"
              onClick={handleClear}
            >
              Clear
            </button>

            <button
              style={{ width: "135px" }}
              className="btn btn-success"
              onClick={handleSave}
              disabled={!isEditable}
            >
              Save
            </button>

          </Col>
        </Row>
      </Card>

      <Card style={{ marginTop: '10px', padding: '15px' }}>
        <h5 className="mb-3">Standards</h5>
        <div className="table-wrapper">
          <table style={{ maxHeight: '35px' }} striped bordered hover className="responsive-table scty-custom-table">
            {/* size="sm"  */}
            <thead>
              <tr>
                <th style={{ width: '5%', textAlign: 'center' }}>#</th>
                <th style={{ width: '15%', textAlign: 'left' }}>Section</th>
                <th style={{ width: '14%', textAlign: 'center' }}>Std Hierarchy</th>
                <th style={{ width: '20%', textAlign: 'left' }}>Std Short Name</th>
                <th style={{ width: '50%', textAlign: 'left' }}>Std Full Name </th>
                <th style={{ width: '10%', textAlign: 'left' }}>Roll NO <br/> Prefix</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Last <br/> Standard</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Generate <br/> Next GR</th>
              </tr>
            </thead>
            <tbody>
              {savedData.length > 0 ? (
                savedData.map((item, index) => (
                  <tr key={item.std_id} onClick={() =>
                    handleRowClick(item)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                    <td style={{ textAlign: 'left' }}>{item.section_desc}</td>
                    <td style={{ textAlign: 'center' }}>{item.std_hierarchy }</td>
                    <td style={{ textAlign: 'left' }}>{item.std_short_name}</td>
                    <td style={{ textAlign: 'left' }}>{item.std_full_name}</td>
                    <td style={{ textAlign: 'left' }}>{item.roll_prefix}</td>
                    <td style={{ textAlign: 'left' }}>{item.last_std }</td>
                    <td style={{ textAlign: 'left' }}>{item.gen_gr}</td>
                    <td style={{ textAlign: 'center' }}>{item.section_id}</td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">No records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div >
      </Card>

      {showDivisionCard && (
        <Card className="mt-3 p-3">
          <Row className="mb-2">
            <Col>
              <h5>
                Divisions for Standard : <b>{formData.std_full_name}</b>
              </h5>
            </Col>
            <Col className="text-end">
              <button
                className="btn btn-sm btn-primary"
                onClick={handleAddDivision}
              >
                + Add Division
              </button>
            </Col>
          </Row>

          {divisions.length === 0 ? (
            <p className="text-muted">No divisions found.</p>
          ) : (
            <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'center' }}>#</th>
                  <th style={{ width: '20%', textAlign: 'left' }}>Division Name</th>
                  <th style={{ width: '15%', textAlign: 'right' }}>Capacity</th>
                  <th style={{ width: '8%', textAlign: 'center' }}>Active</th>
                </tr>
              </thead>
              <tbody>
                {divisions.map((div, idx) => (
                  <tr key={idx}>
                    <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                    <td style={{ textAlign: 'left' }}>

                      <Form.Select
                        name="division_id"
                        value={div.division_id}
                        onChange={(e) => handleDivisionChange(idx, 'division_id', e.target.value)} >
                        <option value="">-- Select Division --</option>

                        {ddlDivisions.map((div) => (
                          <option key={div.div_id} value={div.div_id}>
                            {div.div_short_name}
                          </option>
                        ))}
                      </Form.Select>

                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <input
                        type="number"
                        className="form-control"
                        value={div.capacity}
                        onChange={(e) =>
                          handleDivisionChange(idx, 'capacity', e.target.value)
                        }
                      />
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <select
                        className="form-select"
                        value={div.active}
                        onChange={(e) =>
                          handleDivisionChange(idx, 'active', e.target.value)
                        }
                      >
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          &nbsp;
          <div className="text-end">
            <button
              className="btn btn-success"
              onClick={handleSaveDivisions}
            >
              Save Divisions
            </button>
          </div>
        </Card>
      )}


    </Container>
  );
};

export default Standard_Division;
